import axios from "axios";
import { getAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;
const token = localStorage.getItem("token");

export const getUserSettingsById = async (id) => {
  try {
    const userSettings = await axios.get(`${backendUrl}/settings/user/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return userSettings.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getLanguageOptions = async () => {
  try {
    const response = await axios.get(`${backendUrl}/settings/user/languages`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// ---- NOTIFICATIONS SETTINGS ----
export const getEmailNotificationSettingsById = async () => {
  try {
    const response = await axios.get(
      `${backendUrl}/settings/user/emailnotification`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data.emailnotification;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getEmailReportSettingsById = async () => {
  try {
    const response = await axios.get(
      `${backendUrl}/settings/user/emailreport`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.data.emailreport;
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getShrinkageControlSettingsById = async () => {
  console.log("Fetching shrinkage control settings in API...");
  try {
    const response = await axios.get(
      `${backendUrl}/settings/user/shrinkagecontrol`,
      { headers: getAuthHeaders() },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/* export const getEmailReportSettingsById = async () => {
  try {
    const response = await axios.get(
      `${backendUrl}/settings/user/emailreport`,
      {
        headers: getAuthHeaders(),
      },
    );
    console.log("Email report settings: ", response.data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
 */
// ---------------------------- UPDATE USER SETTINGS ----------------------------

// Update the user's last name from the token
export const updateUserLastNameInSettingsById = async (lastname) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/lastname`,
      { lastname },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

// Update the user's first name from the token
export const updateUserFirstNameInSettingsById = async (firstname) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/firstname`,
      { firstname },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const updateUserEmailInSettingsById = async (email) => {
  console.log("Email in settings user api: ", email);
  try {
    await axios.patch(
      `${backendUrl}/settings/user/email`,
      { email },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    console.log("Error: ", error);
    throw new Error(error);
  }
};

export const updateUserPasswordInSettingsById = async (id, password) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/password/${id}`,
      { password },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const updateUserLanguageInSettingsById = async (id, language) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/language/${id}`,
      { language },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const updateUserTimezoneInSettingsById = async (id, timezone) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/timezone/${id}`,
      { timezone },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const updateUser2FAEnabledInSettingsById = async (id, is2FAEnabled) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/2faenabled/${id}`,
      { is_2fa_enabled: is2FAEnabled },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

// ---- NOTIFICATIONS SETTINGS ----

export const updateUserEmailNotificationSettingsById = async (
  emailNotification,
) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/emailnotification`,
      { emailNotification },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const updateUserEmailReportSettingsById = async (emailReport) => {
  try {
    await axios.patch(
      `${backendUrl}/settings/user/emailreport`,
      { emailReport },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const updateUserShrinkageControlSettingsById = async (value) => {
  try {
    const response = await axios.patch(
      `${backendUrl}/settings/user/shrinkagecontrol`,
      { value },
      { headers: getAuthHeaders() },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
